import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import 'components/common/DatePicker.css';
import ContentLoading from "components/common/ContentLoading";
import SalesPersonSelect from "components/common/SalesPersonSelect";
import serialize from "form-serialize";
import * as moment from "moment";
import * as React from 'react';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { RouteComponentProps } from 'react-router';
import MaskedInput from "react-text-mask";
import apifetch from "utils/apifetch";
import createNumberMask from "utils/createNumberMask";
import extractErrorMessage from "utils/extractErrorMessage";
import normalizePrice from "utils/normalizePrice";


interface Props {
    id: number;
}

interface State {
    isLoading: boolean;
    data: {
        id: number,
        name: string,
        cisNumber?: string,
        jobTypeId?: number,
        bidDate?: Date,
        description?: string,
        costEstimate?: number,
        address?: string,
        city?: string,
        state?: string,
        county?: string,
        salesPerson?: string,
    };
    bidDate?: moment.Moment;
    hasValidationErrors: boolean;
    errorMessage?: string;
}

export default class Edit extends React.Component<RouteComponentProps<Props>, State> {
    public constructor(props: RouteComponentProps<Props>) {
        super(props);

        this.state = {
            isLoading: true,
            data: {
                id: 0,
                name: "",
            },
            hasValidationErrors: false,
            errorMessage: undefined,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBidDateChanged = this.handleBidDateChanged.bind(this);
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading topOffset={350} />
                </div>
            );
        }

        const numberMask = createNumberMask({
            allowDecimal: true,
            allowZeroFractionPadding: true,
        });

        return <div className="container">
            <div className="animated fadeIn">
                <Breadcrumb>
                    <BreadcrumbLink to="/">Home</BreadcrumbLink>
                    <BreadcrumbLink to="/jobs-bqs">Projects</BreadcrumbLink>
                    <BreadcrumbLink isActive={true}>Edit Project</BreadcrumbLink>
                </Breadcrumb>
                <div className="card card--form">
                    <div className="card-block">
                        <form id="add-job" name="form" className="form" onSubmit={this.handleSubmit}>
                            <h3 className="block-title">Edit Project Details</h3>
                            <div className="form-wrapper">
                                {this.state.hasValidationErrors && <DangerAlert name="dangerAlert">{this.state.errorMessage || "An error occurred."}</DangerAlert>}
                                <div className="row">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Project ID</span>
                                        <span className="field-item">{this.state.data.id}</span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">CIS #</span>
                                        <input type="text" name="cisNumber" className="form-control" id="internet-id" maxLength={50} defaultValue={this.state.data.cisNumber} />
                                    </div>
                                    <div className="field-group col-sm-6 d-flex align-items-center">
                                        <span className="field-label me-2">Bid Date</span>
                                        <div className="w-100" style={{ marginLeft: '33px' }}>
                                            <DatePicker name="bidDate" selected={this.state.bidDate} onChange={this.handleBidDateChanged} dateFormat="LL" className="form-control"
                                                popperPlacement='bottom'
                                                popperModifiers={{
                                                    flip: {
                                                        behavior: ['bottom']
                                                    },
                                                    preventOverflow: {
                                                        enabled: false
                                                    },
                                                    hide: {
                                                        enabled: false
                                                    }
                                                }} />
                                        </div>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Type</span>
                                        <select name="jobTypeId" id="type" className="form-control select2-single" defaultValue={this.state.data.jobTypeId ? this.state.data.jobTypeId.toString() : ""}>
                                            <option value="">Select a type</option>
                                            <option value="1">Public</option>
                                            <option value="2">Private</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="field-group">
                                    <span className="field-label">Project Name</span>
                                    <input type="text" name="name" className="form-control" id="job-name" required onInput={e => e.currentTarget.setCustomValidity("")} onInvalid={e => e.currentTarget.setCustomValidity("Project name is required.")} defaultValue={this.state.data.name} />
                                </div>
                                <div className="field-group">
                                    <span className="field-label">Description</span>
                                    <textarea name="description" id="description" rows={6} className="form-control" defaultValue={this.state.data.description}></textarea>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-4">
                                        <span className="field-label">Estimated Cost</span>
                                        <MaskedInput mask={numberMask} name="costEstimate" className="form-control" id="estimated-cost" value={this.state.data.costEstimate ? this.state.data.costEstimate.toString() : ""} />
                                    </div>
                                </div>
                                <div className="field-group">
                                    <span className="field-label">Address</span>
                                    <input type="text" name="address" className="form-control" id="location" maxLength={50} defaultValue={this.state.data.address} />
                                </div>
                                <div className="field-group">
                                    <span className="field-label">City</span>
                                    <input type="text" name="city" className="form-control" id="city" autoComplete="new-password" maxLength={50} defaultValue={this.state.data.city} required onInput={e => e.currentTarget.setCustomValidity("")} onInvalid={e => e.currentTarget.setCustomValidity("City is required.")} />
                                </div>
                                <div className="field-group">
                                    <span className="field-label">State</span>
                                    <input type="text" name="state" className="form-control" id="state" autoComplete="new-password" pattern="[A-Za-z]{2}" maxLength={2} onInput={e => e.currentTarget.setCustomValidity("")} onInvalid={e => e.currentTarget.setCustomValidity("State must be a 2 character abbreviation.")} defaultValue={this.state.data.state} />
                                </div>
                                <div className="field-group">
                                    <span className="field-label">County</span>
                                    <input type="text" name="county" className="form-control" id="county" maxLength={50} defaultValue={this.state.data.county} />
                                </div>
                                <div className="field-group">
                                    <span className="field-label">Salesperson</span>
                                    <SalesPersonSelect name="salesPerson" className="form-control" id="salespersion-id" maxLength={50} defaultValue={this.state.data.salesPerson} text={this.state.data.salesPerson} />
                                </div>
                                <br />
                                <div className="form-actions">
                                    <div className="text-center">
                                        <button type="submit" className="btn btn-primary">Save</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>;
    }

    private async handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
                errorMessage: undefined,
            });
        }

        let data = serialize(e.currentTarget, { hash: true }) as any;

        // Normalize estimated cost to 0000.00
        if (data.costEstimate) {
            data.costEstimate = normalizePrice(data.costEstimate);
        }

        let response = await apifetch("jobs/" + this.props.match.params.id, {
            headers: new Headers({
                Accept: "application/json",
                "Content-Type": "application/json",
            }),
            method: "PUT",
            body: JSON.stringify(data),
        }, true);
        if (response.ok) {
            this.props.history.push("/jobs-bqs/" + this.props.match.params.id);
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({
                hasValidationErrors: true,
                errorMessage: errorText,
            });
        }
    }

    private handleBidDateChanged(date: moment.Moment) {
        this.setState({
            bidDate: date,
        });
    }

    public async componentDidMount() {
        if (this.state.isLoading) {
            let response = await apifetch("jobs/" + this.props.match.params.id, undefined, true);
            if (response.ok) {
                let data = await response.json();
                this.setState({
                    isLoading: false,
                    data: data,
                    bidDate: data.bidDate
                        ? moment(data.bidDate)
                        : undefined,
                });

                document.title = `Editing ${this.state.data.name} - Project - ${SITE_NAME}`;
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isLoading: false,
                    errorMessage: errorText,
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/Projects/Edit.tsx